import { useEffect } from "react";
import { useMainDashboardLayoutContext } from "../../../context/SuperAdmin/DashboardContexts/MainDashboardLayout";
import { useAllOrgsDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllOrganizations";
import { Spinner } from "../../../components/Loading/Spinner";
import { Grid } from "@mui/material";
import AllEntitiesPieCharts from "../../../components/Table/Dashboard/AllEntities/AllEntitiesPieCharts";
import CustomStackedBarChart from "../../../components/Table/Dashboard/AllEntities/CustomStackedBarChart";

const AllOrgsDashboard = () => {
  const { setSelectedOrg } = useMainDashboardLayoutContext();

  const {
    isLoadingCredits,
    totalCredits,
    totalCreditsFilters,
    handleToggleCredit,
  } = useAllOrgsDashboard();

  // Si entramos a esta página, por defecto le asignamos el valor de "organizations" a selectedOrg
  useEffect(() => {
    setSelectedOrg("organizations");
  }, []);

  if (isLoadingCredits) {
    return <Spinner msg="Cargando por favor espere..." />;
  }

  return (
    <Grid container gap={4}>
      <AllEntitiesPieCharts
        credits={totalCredits}
        title="Total organizaciones"
        label="organizacion"
      />
      <CustomStackedBarChart
        credits={totalCredits}
        label="organizacion"
        totalCreditsFilters={totalCreditsFilters}
        handleToggleCredit={handleToggleCredit}
      />
    </Grid>
  );
};

export default AllOrgsDashboard;
